import { render } from "./SitePrevida.vue?vue&type=template&id=aa798798"
import script from "./SitePrevida.vue?vue&type=script&lang=js"
export * from "./SitePrevida.vue?vue&type=script&lang=js"

import "./SitePrevida.vue?vue&type=style&index=0&id=aa798798&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__